import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Login } from 'src/app/models/login.model';
import { LoginService } from 'src/app/services/login.service';
import { AuthPayxService } from 'src/app/services/payx/authPayx.service';

@Component({
  selector: 'app-merchant-login',
  templateUrl: './merchant-login.component.html',
  styleUrls: ['./merchant-login.component.scss']
})
export class MerchantLoginComponent implements OnInit {

  login: Login = new Login();
  loginIsValid: boolean = true;
  errorMessage: string = "";
  loadingToggle:boolean=false;
  booleanForCode:boolean=false;

  successToggle:boolean=false;

  MPToggle:boolean=false;

  registerForm: FormGroup;
  loginForm: FormGroup;
  forgotPasswordGroup: FormGroup;
  resetPassword: FormGroup;
  pass: string;
  showConfirmSide: boolean = false;
  showPasswordReset: boolean = false;
  showLoader: boolean = false;
  showConfirmCodeForgote: boolean = false;
  emailSend: string;
  passwordForLogin: string;
  confirmCodeResponseResetPAssword: number;
  allowPassowrdChange: boolean = false;
  cheked: boolean = false;

  interval:any;
  timeLeft:number=10;
  showTimeLeft:boolean=true;


  @ViewChild('container') container: any;
  @ViewChild('signIn') signIn: any;
  @ViewChild('rulesCheckBox') rules: any;
  @ViewChild('confirmAcc') confirmAcc: any;
  @Input() mainLogin: boolean;


  constructor(private auth:AuthPayxService,
    private loginService:LoginService,
    private router:Router,
    // private messagingService: MessagingService,

    private formBuilder: FormBuilder,private aRoute: ActivatedRoute) { }


  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  loginBtn(){
    if(this.loginForm.get('userName').value == '' || this.loginForm.get('password').value == '' ||
      this.loginForm.get('userName').value == undefined || this.loginForm.get('password').value == undefined)
    {
      return;
    }
    let loginBody: Login = {
      username: this.loginForm.get('userName').value,
      password: this.loginForm.get('password').value
    }
    this.loginService.login(loginBody).subscribe(
      (res) => {
        localStorage.setItem("token", res.headers.get("token"));
        localStorage.setItem("tokenr", res.headers.get("refresh_token"));
        localStorage.setItem("id", res.body["merchantUserId"]);
        this.router.navigateByUrl("user/qr");
      },
      (err) => {
        if (err.status == 401) {
          this.errorMessage = err.error;
          this.loadingToggle=false;
          this.loginIsValid = false;
        }
        if (err.status == 400) {
          this.errorMessage = err.error;
          this.loadingToggle=false;
          this.loginIsValid = false;
        }
      }
    );
  }

}
